import { ajaxRetry } from '../ajaxRetry';
import { UserEntity } from '../../models/user';

import { applicationParameters } from '../../utilities/application-parameters';
import { base, createApiResponse, createApiURL, ResponseObj } from './base';

export type UserResponse = {
  user: UserEntity;
  accessToken: string;
  idHint?: string;
};

export const getUser = async (): Promise<ResponseObj<UserEntity>> => {
  return ajaxRetry({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL('/api/v1/user'),
  });
};

type RegisterAnonymousUserResponse = {
  access_token: string;
  user: UserEntity;
};

export const registerAnonymousUser = async (): Promise<ResponseObj<UserResponse>> => {
  const locale = applicationParameters.get('locale');
  const market = applicationParameters.get('market');
  const headers = base.headers();
  delete headers.Authorization; // Makes sure we can register as a new user several times

  const userResponse = await ajaxRetry<RegisterAnonymousUserResponse>({
    data: JSON.stringify({ locale, market }),
    headers,
    method: 'POST',
    url: createApiURL('/api/v1/user/anonymous'),
  });

  if (userResponse.isOk()) {
    base.setAuthorization(userResponse.data.access_token);

    return createApiResponse<UserResponse>(
      {
        user: userResponse.data.user,
        accessToken: userResponse.data.access_token,
      },
      userResponse.status
    );
  }

  return userResponse as ResponseObj<any>;
};
